import React from 'react';
import Chip from '../../shared/Chip';
import { QueryMenu } from './HistoryPanel';

/**
 * PRD-1623: every thread's header — its title, New query, the query's ⋮ menu (the same one as its
 * History row), and the datasets it uses as chips. These chips replace the composer's "Using:" row.
 * A shared query adds `meta`, its shared line, under the title.
 */
function ThreadHeader({ thread, datasetNames, onNewQuery, menuProps, meta, scrolled }) {
  return (
    <header className={`iter1-thread-header${scrolled ? ' iter1-thread-header--scrolled' : ''}`}>
      <div className="iter1-thread-header-top">
        <h3 className="iter1-thread-title">{thread.title || 'Untitled conversation'}</h3>
        <div className="iter1-thread-header-actions">
          <button type="button" className="resui-btn resui-btn--primary resui-btn--small" onClick={onNewQuery}>
            New query
          </button>
          {menuProps && <QueryMenu trigger="header" thread={thread} {...menuProps} />}
        </div>
      </div>
      {meta}
      {datasetNames.length > 0 && (
        <ul className="iter1-thread-chips" aria-label="Datasets this query uses">
          {datasetNames.map((name) => (
            <li key={name}><Chip variant="dataset">{name}</Chip></li>
          ))}
        </ul>
      )}
    </header>
  );
}

export default ThreadHeader;
